/*
  Sekse wine mixers: sold as a 4-pack (multiples of 4).
  A single pouch may only be bought when the cart also contains a bottle (any non-mixer product).
  Config comes from layout/theme.liquid: window.sekseMixer = { pack, variants: { variantId: productId } }
*/
(function () {
  var cfg = window.sekseMixer;
  if (!cfg || window.__sekseMixerInit) return;
  window.__sekseMixerInit = true;

  var PACK = cfg.pack || 4;
  var VARIANTS = cfg.variants || {};
  var MIXER_IDS = {};
  Object.keys(VARIANTS).forEach(function (v) { MIXER_IDS[VARIANTS[v]] = true; });

  var cart = { items: [] };
  var MSG_RULE = 'Wine mixers are sold in 4-packs. Add a bottle to your order to buy single pouches.';
  var MSG_CART = 'Wine mixers are sold in 4-packs. Add a bottle to your cart to keep single pouches, or change the mixer quantity to 4, 8, 12…';

  function isMixer(item) { return !!MIXER_IDS[item.product_id]; }

  function hasBottle() {
    return cart.items.some(function (i) { return !isMixer(i) && !i.gift_card; });
  }

  function qtyValid(q) { return hasBottle() || (q >= PACK && q % PACK === 0); }

  function mixerLines() { return cart.items.filter(isMixer); }

  function cartInvalid() {
    return mixerLines().some(function (i) { return !qtyValid(i.quantity); });
  }

  function qtyInCart(productId) {
    return cart.items.reduce(function (n, i) { return i.product_id === productId ? n + i.quantity : n; }, 0);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('sekse-mixer-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'sekse-mixer-toast';
      el.setAttribute('role', 'alert');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 5000);
  }

  /* ---------- DOM updates ---------- */
  function setQtyRules(input, mixer) {
    var min = mixer && !hasBottle() ? PACK : 1;
    var step = min;
    if (input.getAttribute('min') !== String(min)) input.setAttribute('min', min);
    if (input.getAttribute('step') !== String(step)) input.setAttribute('step', step);
    if (input.dataset.min !== String(min)) input.dataset.min = min;
    return min;
  }

  function ensureNote(anchor, cls, text) {
    var holder = anchor.parentNode;
    var note = holder.querySelector('.' + cls);
    if (!text) { if (note) note.remove(); return; }
    if (!note) {
      note = document.createElement('p');
      note.className = cls + ' sekse-mixer-note caption';
      anchor.insertAdjacentElement('afterend', note);
    }
    if (note.textContent !== text) note.textContent = text;
  }

  function applyProductPage() {
    document.querySelectorAll('product-info').forEach(function (info) {
      var variantInput = info.querySelector('form[action*="/cart/add"] input[name="id"]');
      var qtyInput = info.querySelector('.product-form__quantity .quantity__input');
      if (!variantInput || !qtyInput) return;
      var mixer = !!VARIANTS[variantInput.value];
      if (!mixer) return;
      var strict = !hasBottle();
      var min = setQtyRules(qtyInput, true);
      var v = parseInt(qtyInput.value, 10) || 0;
      if (v < min || (strict && v % PACK !== 0)) {
        qtyInput.value = Math.max(min, Math.ceil(v / min) * min);
      }
      var minus = info.querySelector('.product-form__quantity .quantity__button[name="minus"]');
      if (minus) minus.classList.toggle('disabled', parseInt(qtyInput.value, 10) <= min);
      ensureNote(qtyInput.closest('quantity-input') || qtyInput, 'sekse-mixer-note--pdp',
        strict ? 'Sold as a 4-pack. Singles available when you add a bottle to your order.'
               : 'Bottle in your cart: you can add single pouches.');
      info.querySelectorAll('.shopify-payment-button, .product-form__buttons [data-shopify="payment-button"]').forEach(function (b) {
        b.style.display = strict ? 'none' : '';
      });
    });
  }

  function applyCart() {
    var invalid = false;
    var byVariant = {};
    cart.items.forEach(function (i) { byVariant[i.variant_id] = i; });
    document.querySelectorAll('.cart-item').forEach(function (row) {
      var input = row.querySelector('.quantity__input');
      if (!input) return;
      var id = input.dataset.quantityVariantId || input.dataset.index;
      var item = byVariant[id] || cart.items[parseInt(row.id.replace(/\D/g, ''), 10) - 1];
      if (!item || !isMixer(item)) return;
      setQtyRules(input, true);
      var bad = !qtyValid(item.quantity);
      if (bad) invalid = true;
      row.classList.toggle('sekse-mixer-line--invalid', bad);
      var anchor = row.querySelector('.cart-item__quantity-wrapper, quantity-popover, .quantity') || input;
      ensureNote(anchor, 'sekse-mixer-note--cart', bad ? MSG_CART : '');
    });
    document.querySelectorAll('#checkout, #CartDrawer-Checkout, .cart__checkout-button').forEach(function (btn) {
      btn.classList.toggle('sekse-mixer-locked', invalid);
      if (invalid) btn.setAttribute('data-sekse-locked', '1'); else btn.removeAttribute('data-sekse-locked');
    });
  }

  var observer;
  function apply() {
    if (observer) observer.disconnect();
    try { applyProductPage(); applyCart(); } finally { observe(); }
  }

  var tm;
  function schedule(delay) { clearTimeout(tm); tm = setTimeout(refresh, delay || 120); }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; apply(); })
      .catch(function () { apply(); });
  }

  function observe() {
    if (!observer) observer = new MutationObserver(function () { schedule(150); });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  /* ---------- guards ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var idEl = form.elements['id'];
    var pid = idEl && VARIANTS[idEl.value];
    if (!pid) return;
    var qEl = form.elements['quantity'];
    var qty = qEl ? parseInt(qEl.value, 10) || 1 : 1;
    if (!qtyValid(qtyInCart(pid) + qty)) {
      /* no bottle in cart: round the add up to a full 4-pack instead of blocking */
      var inCart = qtyInCart(pid);
      var add = Math.ceil((inCart + qty) / PACK) * PACK - inCart;
      if (!qEl) {
        qEl = document.createElement('input');
        qEl.type = 'hidden';
        qEl.name = 'quantity';
        form.appendChild(qEl);
      }
      qEl.value = add;
      toast('Wine mixers are sold in 4-packs, so we added ' + add + ' to your cart.');
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('#checkout, #CartDrawer-Checkout, .cart__checkout-button, a[href^="/checkout"]');
    if (!btn) return;
    if (cartInvalid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toast(MSG_CART);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var sub = e.submitter;
    var goingToCheckout = (sub && sub.name === 'checkout') || (form && form.action && /\/checkout/.test(form.action));
    if (goingToCheckout && cartInvalid()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      toast(MSG_CART);
    }
  }, true);

  /* ---------- boot ---------- */
  function boot() {
    apply();
    refresh();
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(250); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
